import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ENGINE_FEATURE_KEY } from '@blaze-runtime/engine-data-access';

import {
  initialWorkflowDebuggerSlice,
  type WorkflowDebuggerEngineState,
} from './workflow-debugger.state';

/**
 * Reads the `engine` slice as the debugger handlers write it. `workflowDebugger` is absent unless
 * this library's engine-state extension is registered.
 */
const getWorkflowDebuggerEngineState =
  createFeatureSelector<WorkflowDebuggerEngineState>(ENGINE_FEATURE_KEY);

export const selectWfDebugInfo = createSelector(
  getWorkflowDebuggerEngineState,
  (state) => state.workflowDebugger ?? initialWorkflowDebuggerSlice.workflowDebugger,
);
